module.exports={render:function (){with(this) {
  return _h('div', {
    staticClass: "index-nav",
    class: {
      'draping': drap
    },
    style: ({
      'top': navTop + 'px',
      'left': left + 'px'
    })
  }, [_h('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(drap) ? _h('span', [_m(0), " ", _m(1)]) : _e()]), " ", _h('div', {
    staticClass: "nav-list"
  }, [_l((lists), function(item, $index) {
    return _h('div', {
      staticClass: "nav-item",
      class: {
        'activity': $index === nowItem
      },
      on: {
        "click": function($event) {
          navClick(item.top - offsetTop, $index)
        }
      }
    }, ["\n      " + _s(item.name) + "\n    "])
  }), " ", _h('div', {
    staticClass: "nav-item choose",
    style: ({
      'transform': 'translate3d(0, ' + (nowItem + 1) * 32 + 'px, 0)'
    })
  })]), " ", _h('div', {
    staticClass: "nav-item rank",
    attrs: {
      "title": "排序"
    },
    on: {
      "click": changeDraps
    }
  }, [_m(2), _m(3)]), " ", _h('div', {
    staticClass: "gotop"
  }, [_m(4), _h('div', {
    staticClass: "btn_gotop",
    attrs: {
      "title": "返回顶部"
    },
    on: {
      "click": function($event) {
        goScroll(0)
      }
    }
  })])])
}},staticRenderFns: [function (){with(this) {
  return _h('div', {
    staticClass: "nav-bg"
  })
}},function (){with(this) {
  return _h('div', {
    staticClass: "nav-tip"
  })
}},function (){with(this) {
  return _h('i', {
    staticClass: "n-icon-sort"
  })
}},function (){with(this) {
  return _h('p', ["排序"])
}},function (){with(this) {
  return _h('div', {
    staticClass: "s-line"
  })
}}]}


/*****************
 ** WEBPACK FOOTER
 ** ./~/.npminstall/vue-loader/9.5.1/vue-loader/lib/template-compiler.js?id=data-v-7!./~/.npminstall/vue-loader/9.5.1/vue-loader/lib/selector.js?type=template&index=0!./src/components/SliderNav.vue
 ** module id = 38
 ** module chunks = 2
 **/